export default __webpack_public_path__ + "static/media/ART2.f1104c98.jpg";